export const formatCurrency = (value: any): string => {
    const number = Number(value);
    if (isNaN(number)) return '-';

    return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
    }).format(number);
};


export function formatPercentage(value: number): string {
    return `${value.toFixed(2)}%`;
}